import React, { useState, useEffect } from "react";
import { IconName } from "./type";
import { cn } from "@/lib/utils";

export type IconProps = {
  name: IconName;
  size?: number;
  className?: string;
  color?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
};

const Icon: React.FC<IconProps> = ({ name, size = 24, className, color = "currentColor", ...props }) => {
  const [Icon, setIcon] = useState<React.ComponentType<React.SVGProps<SVGSVGElement>> | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadIcon = async () => {
      try {
        const iconModule = await import(`../../../assets/${name}.svg?react`);
        if (isMounted) {
          setIcon(() => iconModule.default);
        }
      } catch (error) {
        console.error("Icon failed to load:", error);
      }
    };

    loadIcon();

    return () => {
      isMounted = false;
    };
  }, [name]);

  if (!Icon) {
    return (
      <div
        style={{ width: size, height: size }}
        className={cn(className, "animate-pulse rounded-full bg-white/10")}
        data-testid={`icon-${name}`}
        aria-hidden
      />
    );
  }

  return (
    <Icon {...props} width={size} height={size} className={className} fill={color} name={`icon-${name}`} aria-hidden />
  );
};

export default Icon;
